import { render } from "./PageSelect.vue?vue&type=template&id=6168acf0"
import script from "./PageSelect.vue?vue&type=script&lang=js"
export * from "./PageSelect.vue?vue&type=script&lang=js"

import "./PageSelect.vue?vue&type=style&index=0&id=6168acf0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__